import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormStorage } from 'src/app/storage/form.service';

@Component({
  selector: 'app-form-received',
  templateUrl: './form-received.component.html',
  styleUrls: ['./form-received.component.scss']
})
export class FormReceivedView implements OnInit {
  email: string = ''
  course: string = ''
  constructor(
    private formStorage: FormStorage,
    private router: Router
  ) {
    if(this.formStorage.infoFormV === undefined || this.formStorage.coursesFormV === undefined){
      this.navigateHome()
      return
    }
    this.email = this.formStorage.infoFormV.value.email
    const courseForm = this.formStorage.coursesFormV.value
    const checked = courseForm.checked
    const courseValue = courseForm.courses.filter((v:any)=>v.id === checked)[0]
    this.course = `${courseValue.name} ${courseValue.lenght}`
  }

  ngOnInit(): void {
  }

  navigateHome(){
    window.location.replace('/')
  }

  navigateToMainWebsite(){
    window.location.replace('https://skolen.adamogeva.no/')
  }

}
